export * from './MenuMoreInfoText';
